<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/home">Home</a></li>
                <li>Gallery</li>
            </ul>
            @if(galleryCategoryData){
            <h2>{{galleryCategoryData.galleryCategory}}</h2>
            @if(galleryCategoryData.galleryCategoryDiscription){
            <p>{{galleryCategoryData.galleryCategoryDiscription}}</p>
            }
            } @else{
            <p>Please Select Gallery Category !!</p>
            }
        </div>
    </div>
    <div class="shape9"><img src="images/shape8.svg" alt="image"></div>
</div>

<div class="events-area pt-100 pb-70">
    <div class="container">
        <div class="events-tabs">
            <ul class="nav-tabset">
                @for (tab of galleryTabs; track tab.galleryId) {
                <li class="nav-tab" [ngClass]="{'active': currentTab === tab.galleryId}">
                    <span (click)="switchTab(tab.galleryId)">
                        {{tab.galleryType}}
                    </span>
                </li>
                }
            </ul>
            <div class="tabs-container">
                @for (tab of galleryTabs; track tab.galleryId) {
                <div class="pane" *ngIf="currentTab === tab.galleryId">
                    <div class="gallery-description">
                        @if(tab.galleryDiscription){
                        <p>{{tab.galleryDiscription}}</p>
                        }
                    </div>
                    <div class="row mt-3">
                        @for (photo of tab.photos; track photo.photoPath; let i = $index) {
                        <div class="col-lg-4 col-md-6 col-sm-6 mb-3 wow animate__animated animate__fadeInUp"
                            data-wow-delay="0.25s">
                            <div class="single-events-box">
                                <div class="image">
                                    <img [src]="imageUrl + photo.photoPath" [alt]="tab.galleryType"
                                        style="object-fit: cover;" (click)="openImagePopup(tab.photos, i)"
                                        class="gallery-image" />
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
</div>

<!-- <div class="image-popup" *ngIf="popupImage" (click)="closePopup()">
    <div class="popup-content" (click)="$event.stopPropagation()">
        <img [src]="popupImage" alt="Preview" /> -->
<!-- <button class="close-btn fa-solid fa-xmark" (click)="closePopup()"></button> -->
<!-- </div>
</div> -->

<div class="image-popup" *ngIf="popupImage" (click)="closePopup()">
    <div class="popup-content" (click)="$event.stopPropagation()">
        <img [src]="popupImage" alt="Preview" />
        <button class="nav-btn prev" (click)="prevImage()">&#10094;</button>
        <button class="nav-btn next" (click)="nextImage()">&#10095;</button>
        <!-- <button class="close-btn fa-solid fa-xmark" (click)="closePopup()"></button> -->
    </div>
</div>